// extracted by mini-css-extract-plugin
module.exports = {"container":"BriefData_container__1KlcW","headerWrap":"BriefData_headerWrap__5Gc6A","header":"BriefData_header__3n_b9","status":"BriefData_status__1StHa"};